// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography from "@insite/mobius/Typography";
import xOrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import React, { useContext } from "react";

const styles = xOrderInformationStyles;

const OrderOrderedBy = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.properties?.orderByFullName) {
        return null;
    }

    return (
        <StyledWrapper {...styles.headingAndTextStyles?.wrapper}>
            <Typography as="h2" {...styles.headingAndTextStyles?.heading} id="OrderOrderedBy">
                {translate("Ordered By")}
            </Typography>
            <Typography {...styles.headingAndTextStyles?.text} aria-labelledby="OrderOrderedBy">
                {order.properties.orderByFullName}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderOrderedBy,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
